module.exports = __webpack_public_path__ + "static/media/consultantImageFour.72f86c87.png";